
export default function Disclaimer() {

    return (
        <div className="highlight darkblue">
            <p className="max-characters-none">AJ Bell Management Limited (company number 03948391), AJ Bell
                Securities Limited (company number 02723420) and AJ Bell Asset Management Limited (company
                number 09742568) are authorised and regulated by the
                Financial Conduct Authority. All companies are registered in England and Wales at 4 Exchange
                Quay, Salford Quays, Manchester M5 3EE. See website for full details. AJ Bell procures the
                provision of the Morningstar Licensed Tools on an “as
                is” basis and does not guarantee the performance of or accept liability for the Licensed Tools.
                To the maximum extent permitted by law, AJ Bell excludes liability for the Licensed Tools,
                including liability for any failure, interruption,
                delay or defect in the performance of any Licensed Tool, unless it arises as a direct result of
                the negligence of AJ Bell.</p>
            <p className="margin-0">© Copyright {new Date().getFullYear()} AJ Bell. All rights reserved.</p>
        </div>
    );

}